import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  Paper,
  Checkbox,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import queryString from "query-string";
// Component
import MapComponent from "../../components/leafletMap";
import EnhancedTableHead from "./head";
import EnhancedTableToolbar from "./toolbar";
import SearchInput from "../SearchInput";
import InfoRecord from "../infoRecord";
import { rowsPerPage } from "../../utils/setting";

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

const useStyles = (theme) => ({
  root: {
    width: "100%",
    // marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    // minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  customCell: {
    padding: "16px",
    color: "#263238",
  },
  containerMap: {
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem",
  },
  styleRow: {
    cursor: "default",
  },
});

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      orderBy: this.props.orderBy,
      selected: [],
      page: 0,
      rowsPerPage: rowsPerPage,
      search: "",
    };
  }
  componentWillMount() {
    this.props.onRef(null);
  }

  async componentDidMount() {
    this.props.onRef(this);
    let { location } = this.props;
    if (location && location.search === "") {
      await this.props.history.push({
        search: queryString.stringify({
          page: 0,
          pageSize: rowsPerPage,
        }),
      });
      this.getList({
        limit: this.state.rowsPerPage,
        page: this.state.page,
      });
    } else if (location && location.search !== "") {
      let { search } = location;
      search = queryString.parse(search);
      this.setState(
        {
          page: search.page || 0,
          rowsPerPage: search.pageSize || rowsPerPage,
        },
        function () {
          this.getList({
            limit: this.state.rowsPerPage,
            page: this.state.page,
          });
        }
      );
    } else {
      this.getList({
        limit: this.state.rowsPerPage,
        page: this.state.page,
      });
    }
  }
  handleSelectAllClick = (event, checked) => {
    if (checked) {
      const { rows = [] } = this.props;
      const newSelecteds = rows.map((n) => n.id);
      this.setState({ selected: newSelecteds });
      return;
    }
    this.setState({ selected: [] });
  };
  handleClick = (event, id) => {
    const { selected = [] } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleSearch = (event) => {
    this.setState({ search: (event && event.target.value) || "" });
  };

  handlePagination() {
    const { page, rowsPerPage } = this.state;
    const { history } = this.props;
    if (history) {
      this.props.history.push({
        search: queryString.stringify({
          page: page,
          pageSize: rowsPerPage,
        }),
      });
    }
  }

  handleChangePage = (event, page) => {
    const _this = this;
    this.setState({ page, selected: [] }, function () {
      _this.getList();
      _this.handlePagination();
    });
  };

  handleChangeRowsPerPage = (event) => {
    const _this = this;
    this.setState(
      { rowsPerPage: event.target.value, selected: [] },
      function () {
        _this.getList();
        _this.handlePagination();
      }
    );
  };

  getList = async (payload = {}, applyFilter) => {
    if (this.props.getList) {
      const { rowsPerPage, page, search } = this.state;
      this.props.getList(
        {
          limit: Number(rowsPerPage),
          page: Number(page),
          search: search,
          ...payload,
        },
        applyFilter
      );
    }
  };
  handleDelete = async () => {
    const { selected = [] } = this.state;
    let check = await this.props.onDelete(selected);
    if (check) {
      this.setState({ selected: [] }, function () {
        this.getList();
      });
    }
    return check;
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  handleRequestSort = (event, property) => {
    let orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy });
  };
  deleteSearchAndGetList = () => {
    this.getList({ search: "" });
    this.handleSearch();
  };
  render() {
    const {
      classes,
      t,
      placeholder,
      showFilter,
      openFilter,
      title,
      contentDialog,
      headCells = [],
      rows = [],
      totalCount,
      count,
      size,
      isCollapse = false,
      collapse = [],
      hiddenSearch = false,
      renderCollapse = "",
      actionColumn,
      infoServiceBranch = {},
      customBtn,
      handleChangeBranch,
      showActionToolbar,
      titleActionToolbar,
      actionToolbar,
      showCheckBoxToolbar,
      titleCheckBoxToolbar,
      actionCheckBoxToolbar,
      nameCheckBoxToolbar,
      valueCheckBoxToolbar,
      filterCustom,
      showFilterBranch,
      showCheckBox = true,
      handleOpenCollapes = () => { },
      hiddenInfoRcord = false,
      hiddenPagination = false,
      renderFirstRecord = () => { },
      customFirstRecord = false,
      onRequestSort = false,
      listFilter = {}
    } = this.props;
    const {
      order,
      orderBy = "",
      selected,
      rowsPerPage,
      page,
      search,
    } = this.state;
    return (
      <div className={classes.root}>
        {!hiddenSearch && (
          <SearchInput
            customBtn={customBtn}
            placeholder={placeholder}
            onChange={this.handleSearch}
            value={search}
            showFilter={showFilter}
            openFilter={openFilter}
            listFilter={listFilter}
            showFilterBranch={showFilterBranch}
            handleChangeBranch={handleChangeBranch}
            filterCustom={filterCustom}
            getList={this.getList}
            deleteSearchAndGetList={this.deleteSearchAndGetList}
          />
        )}
        {!hiddenInfoRcord && (
          <InfoRecord
            page={page}
            total={count}
            rowsPerPage={rowsPerPage}
            infoServiceBranch={infoServiceBranch}
          />
        )}
        <Paper className={classes.paper}>
          {infoServiceBranch && infoServiceBranch.lat && infoServiceBranch.lng && (
            <div className={classes.containerMap}>
              <MapComponent
                onRef={(googleMap) => (this.myGoogleMap = googleMap)}
                fromLat={infoServiceBranch.lat}
                fromLong={infoServiceBranch.lng}
                lat_center={Number(infoServiceBranch.lat || 0)}
                lng_center={Number(infoServiceBranch.lng || 0)}
                heightContainerElement="10vw"
              />
            </div>
          )}
          <EnhancedTableToolbar
            contentDialog={contentDialog}
            title={title}
            numSelected={selected.length}
            onDelete={this.handleDelete}
            showActionToolbar={showActionToolbar}
            titleActionToolbar={titleActionToolbar}
            actionToolbar={actionToolbar}
            showCheckBoxToolbar={showCheckBoxToolbar}
            titleCheckBoxToolbar={titleCheckBoxToolbar}
            actionCheckBoxToolbar={actionCheckBoxToolbar}
            nameCheckBoxToolbar={nameCheckBoxToolbar}
            valueCheckBoxToolbar={valueCheckBoxToolbar}
          />
          <div className={classes.tableWrapper}>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={size}
            >
              <EnhancedTableHead
                classes={classes}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={onRequestSort}
                handleRequestSort={this.handleRequestSort}
                rowCount={rows.length}
                headCells={headCells}
                showCheckBox={showCheckBox}
              />
              <TableBody>
                {renderFirstRecord && customFirstRecord && renderFirstRecord()}
                {stableSort(rows, getSorting(order, orderBy)).map(
                  (row, index) => {
                    const isItemSelected =
                      this.isSelected(row.id) || collapse[index];
                    const isItemChecked = this.isSelected(row.id);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return [
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={isItemSelected}
                        className={isCollapse ? classes.styleRow : ""}
                      >
                        {showCheckBox && (
                          <TableCell
                            onClick={(event) => this.handleClick(event, row.id)}
                            padding="checkbox"
                          >
                            <Checkbox
                              checked={isItemChecked}
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          </TableCell>
                        )}
                        {headCells.map((headCell = {}, indexCells) => {
                          if (headCell.key === "action") {
                            return (
                              <TableCell
                                key={indexCells}
                                className={classes.customCell}
                                style={
                                  isCollapse
                                    ? { cursor: "pointer" }
                                    : { cursor: "default" }
                                }
                                align={headCell.numeric ? "right" : "left"}
                                padding={
                                  headCell.disablePadding ? "none" : "default"
                                }
                              >
                                {actionColumn(row, index)}
                              </TableCell>
                            );
                          } else {
                            let style =
                              headCell.styleComlumn == true && row.styleComlumn
                                ? row.styleComlumn
                                : {}; // border ở cột cuối(trong list user voucher)
                            return (
                              <TableCell
                                key={indexCells}
                                className={style}
                                onClick={() =>
                                  !headCell.disableOpenCollapes &&
                                  handleOpenCollapes(index, row.item)
                                }
                                className={classes.customCell}
                                style={
                                  isCollapse
                                    ? { cursor: "pointer" }
                                    : { cursor: "default" }
                                }
                                align={headCell.numeric ? "right" : "left"}
                                padding={
                                  headCell.disablePadding ? "none" : "default"
                                }
                              >
                                {row[headCell.key]}
                              </TableCell>
                            );
                          }
                        })}
                      </TableRow>,
                      isCollapse && renderCollapse(row, index),
                    ];
                  }
                )}
              </TableBody>
            </Table>
          </div>
          {!hiddenPagination && (
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={Number(totalCount)}
              rowsPerPage={Number(rowsPerPage)}
              page={(Number(page))}
              backIconButtonProps={{
                "aria-label": "previous page",
              }}
              nextIconButtonProps={{
                "aria-label": "next page",
              }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
              labelRowsPerPage={t("rows_per_page")}
              labelDisplayedRows={({ from, to, count }) => `${from}- ${to}`}
            />
          )}
        </Paper>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  order: PropTypes.oneOf(["small", "medium"]).isRequired,
  headCells: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  getList: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  showFilter: PropTypes.bool,
  openFilter: PropTypes.func,
  listFilter: PropTypes.object,
  title: PropTypes.string,
  contentDialog: PropTypes.string,
  headCells: PropTypes.array,
  rows: PropTypes.arrayOf(PropTypes.object),
  totalCount: PropTypes.number,
  count: PropTypes.number,
  size: PropTypes.string,
  isCollapse: PropTypes.bool,
  collapse: PropTypes.array,
  hiddenSearch: PropTypes.bool,
  renderCollapse: PropTypes.node,
  actionColumn: PropTypes.node,
  infoServiceBranch: PropTypes.object,
  customBtn: PropTypes.node,
  handleChangeBranch: PropTypes.func,
  showActionToolbar: PropTypes.bool,
  titleActionToolbar: PropTypes.string,
  actionToolbar: PropTypes.func,
  showCheckBoxToolbar: PropTypes.bool,
  titleCheckBoxToolbar: PropTypes.string,
  actionCheckBoxToolbar: PropTypes.func,
  nameCheckBoxToolbar: PropTypes.string,
  valueCheckBoxToolbar: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  filterCustom: PropTypes.node,
  showFilterBranch: PropTypes.bool,
  showCheckBox: PropTypes.bool,
  handleOpenCollapes: PropTypes.func,
  hiddenInfoRcord: PropTypes.bool,
  hiddenPagination: PropTypes.bool,
  renderFirstRecord: PropTypes.node,
  customFirstRecord: PropTypes.bool,
  onRequestSort: PropTypes.bool,
};
EnhancedTable.defaultProps = {};

export default translate("translations")(withStyles(useStyles)(EnhancedTable));
